import * as x from '../helpers/xmlHelpers';
import * as h from '../helpers/helpers';

export class ProjectAmenity {
    constructor(doc)
    {
		this.label = null
		this.amenityOwnershipType = null
		this.amenityOwnershipTypeOtherDescription = null
		this.amenityType = null
		this.amenityTypeOtherDescription = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.amenityOwnershipType = x.getStringElement(doc, "./ns:AmenityOwnershipType");
		this.amenityOwnershipTypeOtherDescription = x.getStringElement(doc, "./ns:AmenityOwnershipTypeOtherDescription");
		this.amenityType = x.getStringElement(doc, "./ns:AmenityType");
		this.amenityTypeOtherDescription = x.getStringElement(doc, "./ns:AmenityTypeOtherDescription");
   }

	GetAmenityType() {
		var type = h.descriptionOrOther(this.amenityType, this.amenityTypeOtherDescription);
		if (this.amenityType === "BoatSlip" ||  this.amenityType === "UnitStorage") {
			var ownership = this.GetAmenityOwnership();
			if (!h.isEmpty(ownership)) type += " (" + ownership + ")";
		}
	return type;
	}

	GetAmenityOwnership() {
		return h.descriptionOrOther(this.amenityOwnershipType, this.amenityOwnershipTypeOtherDescription);
	}

}

export class ProjectBlanketFinancing {
    constructor(doc)
    {
		this.label = null
		this.amortizationType = null
		this.amortizationTypeOtherDescription = null
		this.balloonIndicator = null
		this.currentInterestRatePercent = null
		this.interestRateAvailableIndicator = null
		this.lienPriorityType = null
		this.lineOfCreditDrawnAmount = null;
		this.lineOfCreditDrawnProRataShareAttributableToUnitAmount = null;
		this.lineOfCreditIndicator = null
		this.lineOfCreditMaximumAmount = null;
		this.lineOfCreditMaximumProRataShareAttributableToUnitAmount = null;
		this.loanRemainingMaturityTermMonthsCount = null
		this.paymentAmountAvailableIndicator = null
		this.paymentFrequencyType = null
		this.totalPaymentAmount = null;
		this.UPBAmount = null;
		this.UPBProRataShareAttributableToUnitAmount = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.amortizationType = x.getStringElement(doc, "./ns:AmortizationType");
		this.amortizationTypeOtherDescription = x.getStringElement(doc, "./ns:AmortizationTypeOtherDescription");
		this.balloonIndicator = x.getBooleanElement(doc, "./ns:BalloonIndicator");
		this.currentInterestRatePercent = x.getStringElement(doc, "./ns:CurrentInterestRatePercent");
		this.interestRateAvailableIndicator = x.getBooleanElement(doc, "./ns:InterestRateAvailableIndicator");
		this.lienPriorityType = x.getStringElement(doc, "./ns:LienPriorityType");
		this.lineOfCreditDrawnAmount  = x.getMISMOAmountElement(doc, "./ns:LineOfCreditDrawnAmount");
		this.lineOfCreditDrawnProRataShareAttributableToUnitAmount  = x.getMISMOAmountElement(doc, "./ns:LineOfCreditDrawnProRataShareAttributableToUnitAmount");
		this.lineOfCreditIndicator = x.getBooleanElement(doc, "./ns:LineOfCreditIndicator");
		this.lineOfCreditMaximumAmount  = x.getMISMOAmountElement(doc, "./ns:LineOfCreditMaximumAmount");
		this.lineOfCreditMaximumProRataShareAttributableToUnitAmount  = x.getMISMOAmountElement(doc, "./ns:LineOfCreditMaximumProRataShareAttributableToUnitAmount");
		this.loanRemainingMaturityTermMonthsCount = x.getIntegerElement(doc, "./ns:LoanRemainingMaturityTermMonthsCount");
		this.paymentAmountAvailableIndicator = x.getBooleanElement(doc, "./ns:PaymentAmountAvailableIndicator");
		this.paymentFrequencyType = x.getStringElement(doc, "./ns:PaymentFrequencyType");
		this.totalPaymentAmount  = x.getMISMOAmountElement(doc, "./ns:TotalPaymentAmount");
		this.UPBAmount  = x.getMISMOAmountElement(doc, "./ns:UPBAmount");
		this.UPBProRataShareAttributableToUnitAmount  = x.getMISMOAmountElement(doc, "./ns:UPBProRataShareAttributableToUnitAmount");
   }

	 GetAmortizationType() {
	 		return h.descriptionOrOther(this.amortizationType, this.amortizationTypeOtherDescription);
	 }
}

export class ProjectComponent {
    constructor(doc)
    {
		this.label = null
		this.projectComponentCategoryType = null
		this.projectComponentCategoryTypeOtherDescription = null
		this.projectComponentCompletedIndicator = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.projectComponentCategoryType = x.getStringElement(doc, "./ns:ProjectComponentCategoryType");
		this.projectComponentCategoryTypeOtherDescription = x.getStringElement(doc, "./ns:ProjectComponentCategoryTypeOtherDescription");
		this.projectComponentCompletedIndicator = x.getBooleanElement(doc, "./ns:ProjectComponentCompletedIndicator");
   }

	GetComponentType() {
		return h.descriptionOrOther(this.projectComponentCategoryType, this.projectComponentCategoryTypeOtherDescription);
	}

}

export class ProjectDetail {
    constructor(doc)
    {
		this.label = null
		this.legalActionIndicator = null
		this.projectCommercialSpaceIndicator = null
		this.projectCommercialSpacePercent = null
		this.projectCompletedIndicator = null
		this.projectDwellingUnitCount = null
		this.projectDwellingUnitsForSaleCount = null
		this.projectDwellingUnitsRentedCount = null
		this.projectDwellingUnitsRentedEstimateDescription = null
		this.projectDwellingUnitsRentedEstimateIndicator = null
		this.projectDwellingUnitsSoldCount = null
		this.projectLegalStructureType = null
		this.projectName = null
		this.subjectBuildingCompletedIndicator = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.legalActionIndicator = x.getBooleanElement(doc, "./ns:LegalActionIndicator");
		this.projectCommercialSpaceIndicator = x.getBooleanElement(doc, "./ns:ProjectCommercialSpaceIndicator");
		this.projectCommercialSpacePercent = x.getStringElement(doc, "./ns:ProjectCommercialSpacePercent");
		this.projectCompletedIndicator = x.getBooleanElement(doc, "./ns:ProjectCompletedIndicator");
		this.projectDwellingUnitCount = x.getIntegerElement(doc, "./ns:ProjectDwellingUnitCount");
		this.projectDwellingUnitsForSaleCount = x.getIntegerElement(doc, "./ns:ProjectDwellingUnitsForSaleCount");
		this.projectDwellingUnitsRentedCount = x.getIntegerElement(doc, "./ns:ProjectDwellingUnitsRentedCount");
		this.projectDwellingUnitsRentedEstimateDescription = x.getStringElement(doc, "./ns:ProjectDwellingUnitsRentedEstimateDescription");
		this.projectDwellingUnitsRentedEstimateIndicator = x.getBooleanElement(doc, "./ns:ProjectDwellingUnitsRentedEstimateIndicator");
		this.projectDwellingUnitsSoldCount = x.getIntegerElement(doc, "./ns:ProjectDwellingUnitsSoldCount");
		this.projectLegalStructureType = x.getStringElement(doc, "./ns:ProjectLegalStructureType");
		this.projectName = x.getStringElement(doc, "./ns:ProjectName");
		this.subjectBuildingCompletedIndicator = x.getBooleanElement(doc, "./ns:SubjectBuildingCompletedIndicator");
   }
}

export class ProjectDeveloper {
    constructor(doc)
    {
		this.label = null
		this.projectDeveloperOrSponsorControlsProjectManagementIndicator = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.projectDeveloperOrSponsorControlsProjectManagementIndicator = x.getBooleanElement(doc, "./ns:ProjectDeveloperOrSponsorControlsProjectManagementIndicator");
   }
}

export class ProjectFinancialInformation {
    constructor(doc)
    {
		this.label = null
		this.projectBlanketFinancingIndicator = null
		this.projectTotalSharesIssuedAndOutstandingCount = null
		this.singleEntityGreatestNumberOfSharesCount = null
		this.singleEntityGreatestNumberOfUnitsCount = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.projectBlanketFinancingIndicator = x.getBooleanElement(doc, "./ns:ProjectBlanketFinancingIndicator");
		this.projectTotalSharesIssuedAndOutstandingCount = x.getIntegerElement(doc, "./ns:ProjectTotalSharesIssuedAndOutstandingCount");
		this.singleEntityGreatestNumberOfSharesCount = x.getIntegerElement(doc, "./ns:SingleEntityGreatestNumberOfSharesCount");
		this.singleEntityGreatestNumberOfUnitsCount = x.getIntegerElement(doc, "./ns:SingleEntityGreatestNumberOfUnitsCount");
   }
}

export class ProjectAnalysis {
		constructor(doc)
		{
		this.label = null
		this.projectAnalysisGroundRentAmount = null;
		this.projectAnalysisGroundRentDescription = null
		this.projectAnalysisGroundRentExpirationDate = null
		this.projectAnalysisGroundRentIndicator = null
		this.projectConditionAndQualityDescription = null
		this.projectDeficiencyObservedIndicator = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.projectAnalysisGroundRentAmount  = x.getMISMOAmountElement(doc, "./ns:ProjectAnalysisGroundRentAmount");
		this.projectAnalysisGroundRentDescription = x.getStringElement(doc, "./ns:ProjectAnalysisGroundRentDescription");
		this.projectAnalysisGroundRentExpirationDate = x.getMISMODateElement(doc, "./ns:ProjectAnalysisGroundRentExpirationDate");
		this.projectAnalysisGroundRentIndicator = x.getBooleanElement(doc, "./ns:ProjectAnalysisGroundRentIndicator");
		this.projectConditionAndQualityDescription = x.getStringElement(doc, "./ns:ProjectConditionAndQualityDescription");
		this.projectDeficiencyObservedIndicator = x.getBooleanElement(doc, "./ns:ProjectDeficiencyObservedIndicator");
	 }
}

export class Project {
    constructor(doc)
    {
		this.label = null
		this.projectAmenities = []
		this.projectAnalysis = null;
		this.projectBlanketFinancings = []
		this.projectComponents = []
		this.projectConversion = null
		this.projectDetail = null
		this.projectDeveloper = null
		this.projectFinancialInformation = null
		var node;
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		nodes = x.selectNodes(doc, "./ns:PROJECT_AMENITIES/ns:PROJECT_AMENITY");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.projectAmenities.push(new ProjectAmenity(xn));
			});
		}

		node = x.selectSingleNode(doc, "./ns:PROJECT_ANALYSIS");
		if (node !== null)
			this.projectAnalysis = new ProjectAnalysis(node);

		nodes = x.selectNodes(doc, "./ns:PROJECT_BLANKET_FINANCINGS/ns:PROJECT_BLANKET_FINANCING");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.projectBlanketFinancings.push(new ProjectBlanketFinancing(xn));
			});
		}
		nodes = x.selectNodes(doc, "./ns:PROJECT_COMPONENTS/ns:PROJECT_COMPONENT");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.projectComponents.push(new ProjectComponent(xn));
			});
		}
		this.projectConversion = x.getStringElement(doc, "./ns:PROJECT_CONVERSION");
		node = x.selectSingleNode(doc, "./ns:PROJECT_DETAIL");
		if (node !== null)
				this.projectDetail = new ProjectDetail(node);
		node = x.selectSingleNode(doc, "./ns:PROJECT_DEVELOPER");
		if (node !== null)
				this.projectDeveloper = new ProjectDeveloper(node);
		node = x.selectSingleNode(doc, "./ns:PROJECT_FINANCIAL_INFORMATION");
		if (node !== null)
				this.projectFinancialInformation = new ProjectFinancialInformation(node);
   }

	GetAmenities(spacer) {
		var amenities = "";
		if (this.projectAmenities === 0) return amenities;
		for(var amenity of this.projectAmenities) {
			if (spacer) {
				amenities = h.addWithSpacer(amenities, amenity.GetAmenityType(), spacer);
			} else {
				amenities = h.addWithNewline(amenities, amenity.GetAmenityType());
			}
		}
		return amenities;
	}

	GetAmenitiesList() {
		var amenities = [];
		if (this.projectAmenities === 0) return amenities;
		for (var amenity of this.projectAmenities) {
			amenities.push(amenity.GetAmenityType());
		}

		return amenities;
	}

	GetComponentTypes() {
		var cats = "";
		if (this.projectComponents === 0) return cats;
		for (var pc of this.projectComponents)
			cats = h.addWithSpacer(cats, pc.GetComponentType());
		return cats;
	}

	GetUnitsRented() {
	var rented = "";
	if (this.projectDwellingUnitsRentedEstimateIndicator ?? false) rented = "~";
	rented += this.projectDwellingUnitsRentedCount;
	return rented;
	}
	
	HasLineOfCredit() {
	if (this.projectBlanketFinancings.length === 0)
		for(var pbf of this.projectBlanketFinancings)
			if (pbf.lineOfCreditIndicator ?? false) return true;
	return false;
	}

}


// end
